import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { DataService } from "../../data.service";

@Component({
  selector: "lc-account-page",
  templateUrl: "./account-page.component.html",
  styleUrls: ["./account-page.component.scss"],
})
export class AccountPageComponent implements OnInit {
  oid: string;
  order_details: any;
  user_details: any;
  meeting_details: any;

  constructor(
    public dataService: DataService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    try {
      window["set_page_name"]("account_page");
    } catch (e) {}
    this.route.params.subscribe((params) => {
      let action = "order";
      if (window.location.pathname.indexOf("auto_login") > -1) {
        action = "subuser";
      }
      if (window.location.pathname.indexOf("start_meeting") > -1) {
        action = "meeting";
      }
      this.oid = params["oid"];
      let h = params["h"];
      let s = params["s"];
      // debugger;
      if (!!this.oid && !!h && !!s) {
        let token_from_hash = `${h}|||${s}`;
        this.dataService.subuser_info = { token: token_from_hash };
        this.dataService.get_unconfirmed(action, this.oid).subscribe(
          (res) => {
            let parent_code: string;
            if (action == "order") {
              let parent_code = res.ordered_by;
              this.order_details = res;
              if (!!res.sub_user) {
                this.dataService.subuser_info = res.sub_user;
                this.dataService.subuser_info.token = token_from_hash;
              }
            }

            if (action == "meeting") {
              this.meeting_details = res;
              if (!!res.sub_user) {
                this.dataService.subuser_info = res.sub_user;
                this.dataService.subuser_info.token = token_from_hash;
              }
            }

            if (action == "subuser") {
              this.dataService.subuser_info = res;
              if (
                !this.dataService.subuser_info.user_id &&
                !!this.dataService.subuser_info.id
              ) {
                this.dataService.subuser_info.user_id = this.dataService.subuser_info.id;
              }
              this.dataService.subuser_info.token = token_from_hash.replace('gpn', this.dataService.subuser_info.user_id);
              this.dataService.is_logged_in = true;
              parent_code = res.parent;
            }
            if (!!parent_code) {
              this.dataService.getUserForCode(parent_code).subscribe(
                (parent) => {
                  this.user_details = parent;
                  this.dataService.user_info = parent;
                  if (action == "subuser") {
                    this.router.navigate(["/shop"]);
                  }
                },
                (error) => {
                  this.user_details = null;
                  this.dataService.user_info = {};
                }
              );
            }
          },
          (error) => {
            this.order_details = null;
          }
        );
      }
    });
  }
}



// WEBPACK FOOTER //
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/pages/account-page/account-page.component.ts